import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Error404 } from '@/graphql/__generated/sdk';
import AspectRatioPaddingBox from '../AspectRatioPaddingBox';
import ContentfulButton from '../ContentfulButton';
import ImageWrapper from '../ImageWrapper';
import TAGButton from '../TAGButton';
import { getInnerWrapperStyles, wrapper, contentStyles, contentWrapperStyles, buttonWrapperStyles, backgroundImageStyles, getBodyStyles, getHeadingStyles, getSubtitleStyles } from './ErrorPage.styles';
import { BACKGROUND_IMAGE_QUALITY } from '@shared-components/constants';
export interface IErrorPage {
  heading: string;
  buttonLabel: string;
  body: string;
  subtitle: string;
  backgroundImageUrl: string;
  backgroundImageUrlMobile: string;
  darkTextColor?: boolean;
  supplementaryButton?: Error404['supplementaryButton'];
}
export default function ErrorPage({
  heading,
  body,
  subtitle,
  buttonLabel,
  backgroundImageUrl,
  backgroundImageUrlMobile,
  darkTextColor,
  supplementaryButton
}: IErrorPage) {
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('md'));
  return <Box component="section" data-testid="section_errorPage" sx={wrapper} data-sentry-element="Box" data-sentry-component="ErrorPage" data-sentry-source-file="ErrorPage.tsx">
			<Box sx={getInnerWrapperStyles({
      theme,
      templateWidth: 'Full',
      shouldApplyDarkOverlay: false,
      contentPositionSmallScreen: 'Bottom'
    })} data-sentry-element="Box" data-sentry-source-file="ErrorPage.tsx">
				<AspectRatioPaddingBox contentfulAspectRatio="1/2" data-sentry-element="AspectRatioPaddingBox" data-sentry-source-file="ErrorPage.tsx">
					<ImageWrapper style={backgroundImageStyles} src={isSmallDevice ? backgroundImageUrlMobile : backgroundImageUrl} alt="errorPage_background_image" data-testid="img_errorPage_background" layout="fill" quality={BACKGROUND_IMAGE_QUALITY} priority="true" data-sentry-element="ImageWrapper" data-sentry-source-file="ErrorPage.tsx" />
				</AspectRatioPaddingBox>

				<Box data-testid="section_errorPage_content_wrapper" sx={contentWrapperStyles} data-sentry-element="Box" data-sentry-source-file="ErrorPage.tsx">
					<Box data-testid="section_errorPage_content" sx={contentStyles} data-sentry-element="Box" data-sentry-source-file="ErrorPage.tsx">
						{heading && <Box>
								<Typography variant={isSmallDevice ? 'heroMedium' : 'heroLarge'} whiteSpace="pre-line" data-testid="text_errorPage_heading" sx={getHeadingStyles({
              isSmallDevice,
              theme,
              darkTextColor
            })}>
									{heading}
								</Typography>
							</Box>}
						{subtitle && <Box>
								<Typography variant="header3" whiteSpace="pre-line" data-testid="text_errorPage_subtitle" sx={getSubtitleStyles({
              isSmallDevice,
              theme,
              darkTextColor
            })}>
									{subtitle}
								</Typography>
							</Box>}
						{body && <Box>
								<Typography variant="header4" whiteSpace="pre-line" data-testid="text_errorPage_subtitle_body" sx={getBodyStyles({
              theme,
              darkTextColor
            })}>
									{body}
								</Typography>
							</Box>}
						<Box data-testid="group_errorPage_buttons_wrapper" sx={buttonWrapperStyles} data-sentry-element="Box" data-sentry-source-file="ErrorPage.tsx">
							<TAGButton fullWidth={isSmallDevice} href="/" dataTestId="button_error_page" size="M" variant={darkTextColor ? 'secondaryDefault' : 'secondaryHC'} data-sentry-element="TAGButton" data-sentry-source-file="ErrorPage.tsx">
								{buttonLabel}
							</TAGButton>
							{supplementaryButton?.label && supplementaryButton?.buttonLink && <ContentfulButton {...supplementaryButton} fullWidth={isSmallDevice} />}
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>;
}